import { Route, Routes } from "react-router-dom"
import List from "./view/List"
import { Upsert } from "./view/Upsert"

export const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<List />} />
      <Route path=":id" element={<Upsert />} />
    </Routes>
  )
}
